// @flow
/* eslint-disable no-template-curly-in-string */

export default {
  All: '全て',
  AllDocuments: 'すべての文書',
  Any: 'どれでも',
  Today: '今日',
  Yesterday: '昨日',
  LastWeek: '先週',
  LastMonth: '先月',
  DateFrom: 'から',
  DateTo: 'に',
  DateRange: '日付範囲',
  NeverViewed:
    '最後に表示してから一度も表示されていない、または変更されていない',
  AddedLastLogin: '前回のログイン以降に追加または変更されました',
  GlobalNetworkErrorMessage:
    'ネットワークに問題があります。もう一度試すか、サポートにお問い合わせください。',
  GlobalIntermediateProxyErrorMessage:
    'ネットワークはデータルームへのこのリクエストを傍受しました。 IT 部門にお問い合わせください。',
  GlobalUnexpectedErrorWithIdMessage:
    'データルームに問題があります。このコード \u003c[ErrorId]\u003eをクライアント サービス チームに伝えてください。',
  GlobalUnexpectedErrorMessage:
    'データルームに問題があります。当社のクライアントサービスチームにお問い合わせください。',
  NoRecordsFound: '記録が見つかりませんでした。',
  Save: '保存',
  Print: '印刷する',
  ViewAs: 'として表示',
  Documents: '書類',
  Date: '日付',
  HideEmptyFolders: '空のフォルダーを非表示にする',
  Search: '検索',
  Actions: '行動',
  Filter: 'フィルター',
  Self: 'あなた',
  Allowed: '許可された',
  Denied: '拒否されました',
  PleaseEnterValidToDate: '有効な日付を入力してください。',
  PleaseEnterValidFromDate: '有効な開始日を入力してください。',
  SavingAllowed: '保存可能',
  SavingDenied: '保存が拒否されました',
  PrintingAllowed: '印刷許可',
  PrintingDenied: '印刷が拒否されました',
  ChooseLanguage: '言語を選択',
  EditProfile: 'プロファイル編集',
  DataRooms: 'データルーム',
  Administration: '管理',
  MyAccount: '私のアカウント',
  Profile: 'プロフィール',
  Logout: 'ログアウト',
  Loading: '読み込み中',
  Success: '成功',
  Disabled: '無効',
  Ok: 'わかりました',
  And: 'そして',
  Demo: 'デモ',
  TenderSubmissionsStart: '提出プロセスを開始する',
  TenderSubmissionsOverdue:
    '提出プロセスは終了しました。今アップロードするドキュメントは遅延としてマークされます。',
  TenderSubmissionsClose: '提出プロセスは終了しました。',
  Later: '後で',
  StartNow: '今すぐ始めましょう',
  StartSubmissionDialogTitle: '提出プロセスを開始する',
  StartSubmissionDialogContent:
    '入札者には、ドキュメントをアップロードして表示できることが通知されます。 ' +
    '社内チームは、提出プロセス中にドキュメントにアクセスできません。',
  StartSubmissionDialogCloseDateContent:
    '送信プロセスは ${closeDate} に終了します。',
  SubmissionInformationIsIncomplete: '提出情報が不完全です。 ',
  BidderTeamsHaveNotBeenInvitedOrHaveBeenRemoved:
    '入札者は招待されていないか、削除されています。 ',
  InviteBidderTeams: '入札者を招待する',
  UpdateSecuritySettings: 'セキュリティ設定を更新する',
  UpdateTheirSecuritySettings: 'セキュリティ設定を更新します。',
  OnTimeSubmission: '期限内に提出',
  LateSubmission: '提出が遅れた場合',
  DeleteAllDocuments: '提出書類をすべて削除する',
  Manage: '管理',
  ManageSubmissions: '提出物の管理',
  NotStarted: '始まっていない',
  Closed: '閉まっている',
  ExtraTime: '延長戦で',
  Open: '開ける',
  CreateTheStructureAndSetTheCloseDateForBidderSubmissions:
    '構造を作成し、入札者提出の締め日を設定します。',
  AddSubmissionWindow: '提出ウィンドウを追加',
  BiddersDoNotHaveAccessToAddSubmissionsSingular:
    '1 人の入札者には提出物を追加するアクセス権がありません。',
  BiddersDoNotHaveAccessToAddSubmissionsPlural:
    '${totalBidders} 入札者には、送信を追加するアクセス権がありません。',
  BulkRedactionCurrentDocumentNumberOfTotal:
    '${currentDocumentNumber} の ${totalDocsCount} ドキュメント',
  BulkRedactionMarksToRedact: '${selectedMarksCount} 項目を編集する',
  BulkRedactionMarksRedacted: '${redactionMarksCount} 項目が編集されました',
  BulkRedactionSkipAndNext: 'ドキュメントをスキップする',
  BulkRedactionSkipAndFinish: 'スキップして編集を終了する',
  BulkRedactionSaveAndNext: '保存して次の文書を作成する',
  BulkRedactionSaveAndFinish: '保存して編集を終了する',
  BulkRedactionRedactAllRemainingDocuments:
    'すべての ${documentsRemaining} ドキュメントを編集します',
  BulkRedactionCancel: 'キャンセル',
};
